const namespace = 'office/'

export const SET_OFFICES = namespace + '.SET_OFFICES'
